/**
 * Converte uma string de data 'AAAA-MM-DD' de um input para um formato ISO String
 * que respeita o fuso horário local, evitando o problema do dia anterior.
 * @param {string} dateString - A data no formato 'AAAA-MM-DD'.
 * @returns {string | null} A data em formato ISO String ou null se a entrada for inválida.
 */
import { Timestamp } from "firebase/firestore";
export const convertInputDateToISO = (dateString) => {
    if (!dateString || typeof dateString !== "string") {
        return null;
    }
    const localDate = new Date(dateString.replace(/-/g, "/"));
    return localDate.toISOString();
};

/**
 * NOVO: Converte uma data em formato ISO String (vindo do backend) para o formato 'AAAA-MM-DD'
 * para ser usada em um <input type="date">, respeitando o fuso horário. (Função para LER dados)
 * @param {string} isoString - A data em formato ISO String (ex: "2025-09-12T03:00:00.000Z").
 * @returns {string | ''} A data no formato 'AAAA-MM-DD' ou uma string vazia.
 */
export const formatISOToInputDate = (isoString) => {
    if (!isoString) {
        return "";
    }
    try {
        const date = new Date(isoString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");

        return `${year}-${month}-${day}`;
    } catch (error) {
        console.error("Erro ao formatar data ISO:", error);
        return "";
    }
};

export const ISOToFirestore = (isoDate) =>
{
    if(!isoDate)
        return null;
    const date = isoDate instanceof Date ? isoDate : new Date(isoDate);
    return Timestamp.fromDate(date);
}

/**
 * @param {string} isoString
 * @returns {string}
 */
export const formatDateToBrazilian = (isoString) => {
    if (!isoString) {
        return "N/A";
    }
    try {
        const date = new Date(isoString);
        // toLocaleDateString com o locale 'pt-BR' e timezone ajustado
        return date.toLocaleDateString("pt-BR", {
            timeZone: "America/Sao_Paulo",
        });
    } catch (error) {
        console.error("Erro ao formatar data para o padrão brasileiro:", error);
        return "Data inválida";
    }
};
